module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Minus-e14d6dc7820e245af330366110045ba5.svg";